module.exports = __webpack_public_path__ + "img/default_image.94d810ba.jpg";